<template>
  <v-card class="mt-4">
    <v-card-title
      ><span>
        {{ name }}
      </span>
      <v-spacer />
      <v-icon v-if="!isFormValid" color="error">warning</v-icon>
      <v-btn icon @click="$emit('edit')">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-card disabled flat>
      <v-card-text>
        <v-row
          no-gutters
          v-for="(content, index) in contents"
          :key="index"
          class="mb-4"
          justify="start"
        >
          <v-col
            cols="12"
            :class="content.fieldType == 'textBold' ? 'font-weight-bold' : ''"
            >{{ getCurrentLocaleOrFirst(content).value }}
          </v-col>
          <v-col
            :cols="
              content.fieldType == 'text' || content.fieldType == 'textBold'
                ? 0
                : '12'
            "
          >
            <v-rating
              v-if="content.fieldType == 'rating'"
              color="primary"
              dense
            />
            <v-textarea
              v-else-if="content.fieldType == 'textarea'"
              rows="1"
              auto-grow
            />
            <template v-else-if="content.fieldType == 'checkbox'">
              <v-row no-gutters class="ml-2">
                <v-col>
                  <v-checkbox
                    hide-details
                    style="margin-top: 0px !important"
                    :label="$t('dialog.yes')"
                  />
                </v-col>
                <v-col>
                  <v-checkbox
                    hide-details
                    style="margin-top: 0px !important"
                    :label="$t('dialog.no')"
                  />
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    contents: {
      type: Array,
      required: true,
    },
    isFormValid: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    getCurrentLocaleOrFirst(content) {
      return (
        content.labelLocales.find(
          (labelLocale) => labelLocale.language == this.$i18n.locale
        ) || content.labelLocales[0]
      );
    },
  },
};
</script>
